import React, { useState, useEffect, useMemo } from 'react';
import {
  Button,
  Table,
  Drawer,
  Upload,
  Radio,
  Tabs,
  Select,
  Form,
  message,
  Modal,
  Alert,
  Checkbox,
} from '@drip/drip-design';
import {
  listApplyWhite,
  queryApplyWhiteForm,
  uploadWhiteFile,
  queryFileTaskResult,
  commitWhiteApply,
} from '../apis.js';
import HeaderInfo from '../headerInfo';
import AppliedList from '../applied';
import ApplyBaseFrom from '../applyBaseFrom';
import ApproveModel, { AugitFlow } from '../approveModel';
import { formateTimeStamp } from '@/common/utils/index';
import SubmitTopSvg from '@/components/SpacialListConfig/image/submit-top.svg';
import { useGetAuthRole } from '@/components/SpacialListConfig/getAuthRole';
import ComponentLog from '@/components/component-log';
import { CheckCircleFilled, CloseCircleFilled, LoadingOutlined } from '@drip/drip-design-icons';
import AuthDistribute from '../manage/authDistribute';
import TimestampRangePicker from '@/components/timestamp-RangePicker';

// import './index.less'
interface PropsType {
  businessType: number; // 活动类型, 1:主题活动
  businessId?: string; // 活动code
  title?: string;
  descriptionList?: Array<{ key: string; value: string }>;
  visible: boolean;
  setVisible: any;
  whiteTypeId?: number;
  planCode?: string;
  isManagerOpenAppliedList?: boolean;
  selectCurWhiteTab?: string; // 1 申请  2已申请
  whiteTemplateId?: number; // 管理员跳转申请记录参数
}

function Apply(props: PropsType) {
  const [form] = Form.useForm();

  const {
    visible,
    setVisible,
    businessType,
    businessId,
    title,
    descriptionList,
    whiteTypeId = -1,
    isManagerOpenAppliedList,
    planCode,
    selectCurWhiteTab,
    whiteTemplateId,
  } = props;

  const [ruleModalVisible, setRuleModalVisible] = useState(false);
  const [applyInfo, setApplyInfo] = useState(false);
  const [againSubmit, setAgainSubmit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [tabType, setTabType] = useState('1');
  const [whiteTypeList, setWhiteTypeList] = useState<
    {
      whiteType: -1;
      whiteName: string;
      id: -1;
      applyContent: string;
      applyBeginTime: number;
      applyEndTime: number;
      effectiveBeginTime: number;
      effectiveEndTime: number;
    }[]
  >([]);
  const [whiteTemplateType, setWhiteTemplateType] = useState(-1);
  const [whiteTemplateTypeId, setWhiteTemplateTypeId] = useState(-1);
  const [fromDataConfig, setFromDataConfig] = useState<any>();
  const [fileType, setFileType] = useState(''); // 文件类型（sku、spu、cate1、cate2、cate3、cate123、shopId、venderId）
  const [fileTaskLogId, setFileTaskLogId] = useState(-1);
  const [fileTaskList, setFileTaskList] = useState<any[]>([]);
  const [haveComfirmCheckBox, setHaveComfirmCheckBox] = useState<any>(null);
  const [commitSuccess, setCommitSuccess] = useState(false); //提交成功过后弹窗反馈组件
  const [fileList, setfileList] = useState([]);

  //白名单管理
  const { isPartner } = useGetAuthRole({
    businessType: businessType,
    businessId: businessId,
    planCode: planCode,
  });

  useEffect(() => {
    if (!visible || !commitSuccess) {
      return;
    }
    // 调用
    (window as any).renderUxSceneResearch &&
      (window as any).renderUxSceneResearch({
        app: 'market-center',
        appSecret: 'D18514A0091749DBA5E4B2A8FE5B1777',
        sceneId: '595',
        loginType: '7',
        isDialogVisible: true,
        extra1: 'ux',
      });
    return () => {
      // 卸载
      (window as any).renderUxSceneResearch &&
        (window as any).renderUxSceneResearch({
          app: '',
          appSecret: '',
          sceneId: '',
        });
    };
  }, [visible, commitSuccess]);

  useEffect(() => {
    if (!visible) {
      return;
    }
    // 设置tab 位置
    if (selectCurWhiteTab) {
      setTabType(selectCurWhiteTab);
    }
    if (isManagerOpenAppliedList) {
      setTabType('2');
    }
  }, [visible, selectCurWhiteTab, isManagerOpenAppliedList]);

  useEffect(() => {
    if (!visible) {
      return;
    }
    // 获取白名单类型
    listApplyWhite({ businessType, businessId })
      .then(({ ret, msg, data }) => {
        if (ret === '0' && data) {
          setWhiteTypeList(data?.list);
        }
      })
      .catch((ex) => {
        message.error(ex);
      });
  }, [visible, businessType]);

  const whiteTextSelect = useMemo(() => {
    if (!visible) {
      return [];
    }
    return fromDataConfig?.list?.find((item: any) => item.code === 'whiteTextSelect')?.optionValues;
  }, [visible, fromDataConfig]);

  // 在设置白名单类型后，默认选中第一个选项
  useEffect(() => {
    if (!visible) {
      return;
    }
    // 从选择白名单进入
    if (whiteTypeId !== -1) {
      setWhiteTemplateTypeId(whiteTypeId);
      const curItemData = whiteTypeList?.find((item: any) => item.id === whiteTypeId);
      if (curItemData) {
        setWhiteTemplateType(curItemData?.whiteType);
      }
    } else if (whiteTypeList?.length > 0) {
      setWhiteTemplateTypeId(whiteTypeList[0]?.id);
      setWhiteTemplateType(whiteTypeList[0]?.whiteType);
    }
  }, [whiteTypeList, whiteTypeId]);

  useEffect(() => {
    if (visible && whiteTemplateTypeId !== -1) {
      form.setFieldsValue({ whiteTemplateId: whiteTemplateTypeId });
    }
    if (visible && whiteTextSelect && whiteTextSelect.length > 0) {
      setFileType(whiteTextSelect[0].value);
      form.setFieldsValue({ whiteTextSelect: whiteTextSelect[0].value });
    }
  }, [visible, whiteTemplateTypeId, whiteTextSelect]);

  useEffect(() => {
    if (visible && whiteTemplateTypeId !== -1 && [3].includes(businessType)) {
      const curItemData = whiteTypeList?.find((item: any) => item.id === whiteTemplateTypeId);
      if (curItemData) {
        form.setFieldsValue({
          effectiveTime: {
            start: curItemData.effectiveBeginTime,
            end: curItemData.effectiveEndTime,
          },
        });
      }
    }
  }, [visible, whiteTypeList, whiteTemplateTypeId]);

  useEffect(() => {
    if (!visible) {
      return;
    }
    if (whiteTemplateType === -1) {
      return;
    }
    setLoading(true);
    // 获取基础信息
    queryApplyWhiteForm({ whiteTemplateType })
      .then(({ ret, msg, data }) => {
        if (ret === '0' && data) {
          setFromDataConfig(data);
        }
      })
      .catch((ex) => {
        message.error(ex);
      });
  }, [visible, whiteTemplateType]);

  useEffect(() => {
    if (tabType === '1') {
      (window as any).expLogJSON('whitelist', 'apply_page', '{}');
    }
  }, [tabType]);

  function onClose() {
    setVisible(false);
    setCommitSuccess(false);
    form.resetFields();
    setWhiteTypeList([]);
    setWhiteTemplateType(-1);
    setWhiteTemplateTypeId(-1);
    setFileType('');
    setFileTaskLogId(-1);
    setFileTaskList([]);
  }

  function onCurSelectTypeChange(type: any) {
    // 清除原有白名单类型下所填写的数据
    const fieldsToReset = ['applicantName', 'applicantErp', 'applicantDept'];
    const allFields = form.getFieldsValue();
    Object.keys(allFields).forEach((key: any) => {
      if (!fieldsToReset.includes(key)) {
        form.resetFields([key]);
      }
    });
    setfileList([]); // 清空文件列表
    form.setFieldsValue({
      fileTaskLogId: null,
    });
    setFileTaskLogId(-1);
    setFileTaskList([]);
  }

  function onChange(tabType: any) {
    setTabType(tabType);
    if (tabType === '2') {
      (window as any).log('x_whiteapply_page_1706591686206', '3', '{}');
    }
  }

  const onFromWhiteChange = (e: any) => {
    // 切换白名单方式 清空本地上传文件file
    if (fileType && fileType !== e.target.value) {
      form.setFieldsValue({
        fileTaskLogId: null,
      });
    }
    setFileType(e.target.value);
    // 切换白名单方式 清空上传文件
    setFileTaskLogId(-1);
    setFileTaskList([]);
  };

  // 获取文件上传记录
  function getFileTaskResult(id: number) {
    queryFileTaskResult({ fileTaskLogId: id })
      .then(({ ret, msg, data }) => {
        if (ret === '0' && data) {
          setFileTaskList([data]);
        }
      })
      .catch((ex) => {
        message.error(ex);
      });
  }

  const handleBaseFormSubmit = (formData: any) => {
    // 在这里处理获取到的表单数据
  };

  const isInTimeRange = () => {
    const curItemData = whiteTypeList?.find((item: any) => item.id === whiteTemplateTypeId);
    if (!curItemData) {
      return false;
    }
    const currentTime = Date.now();
    // 开放化
    if ([3].includes(businessType)) {
      return currentTime >= curItemData?.effectiveBeginTime && currentTime <= curItemData?.effectiveEndTime;
    }
    return currentTime >= curItemData?.applyBeginTime && currentTime <= curItemData?.applyEndTime;
  };

  const isInTimeRangText = () => {
    const curItemData = whiteTypeList?.find((item: any) => item.id === whiteTemplateTypeId);
    if (!curItemData) {
      return '当前时间不在黑白名单申请时间范围内';
    }
    // 开放化
    if ([3].includes(businessType)) {
      return `当前时间不在黑白名单申请时间【${formateTimeStamp(
        curItemData?.effectiveBeginTime,
        true
      )}】至【${formateTimeStamp(curItemData?.effectiveEndTime, true)}】内`;
    }
    return `当前时间不在黑白名单申请时间【${formateTimeStamp(
      curItemData?.applyBeginTime,
      true
    )}】至【${formateTimeStamp(curItemData?.applyEndTime, true)}】内`;
  };

  const checkFromContent = () => {
    form
      .validateFields()
      .then((values: any) => {
        // 任需要先判断是否在申请时间范围内
        if (!isInTimeRange()) {
          message.error(isInTimeRangText());
          return;
        }
        setAgainSubmit(true);
        (window as any).expLogJSON('whitelist', 'confirm_page', '{}');
      })
      .catch((errorInfo: string) => {
        console.log('checkFromContent', errorInfo);
      });
  };

  // 提交申请
  const submitWhiteApply = () => {
    setSubmitLoading(true);
    const value = form.getFieldsValue();
    delete value.whiteTemplateId;
    if (value.effectiveTime) {
      delete value.effectiveTime;
    }
    if (value.fileTaskLogId) {
      delete value.fileTaskLogId;
    }
    value.goodsCategoryApprover = value?.goodsCategoryApprover?.split(',');
    value.bossManager = value?.bossManager?.split(',');
    value.bossHigherManager = value?.bossHigherManager?.split(',');
    value.presellPM = value?.presellPM?.split(',');
    value.validProofCutPic = value?.validProofCutPic?.fileList?.map((item: any) => item?.response.url);
    const param = {
      activityCode: businessId,
      activityType: businessType,
      whiteTemplateId: whiteTemplateTypeId,
      fileTaskLogId,
      formData: value,
    };
    commitWhiteApply(param)
      .then(({ ret, msg, data }) => {
        if (ret === '0' && data) {
          setTabType('2');
          setAgainSubmit(false);
          setCommitSuccess(true);
        } else {
          message.error(msg);
        }
      })
      .catch((errorInfo: string) => {
        console.log('checkFromContent', errorInfo);
      })
      .finally(() => {
        setSubmitLoading(false);
      });
  };

  const customRequest = async (e: any) => {
    if (!fileType) {
      message.error('请先选择表单填写方式，再上传白名单文件');
      // 清空本地上传文件file
      form.setFieldsValue({
        fileTaskLogId: null,
      });
      return;
    }

    const { file } = e;
    const formData = new FormData();
    formData.append('file', file);
    if (businessId) {
      formData.append('activityCode', businessId);
    }
    formData.append('activityType', `${businessType}`);
    formData.append('whiteTemplateId', `${whiteTemplateTypeId}`);
    formData.append('fileType', fileType);
    uploadWhiteFile(formData)
      .then((res) => {
        if (res.ret === '0') {
          const {
            data: { fileTaskLogId },
          } = res;
          setFileTaskLogId(fileTaskLogId);
          getFileTaskResult(fileTaskLogId);
        } else {
          message.error(res.msg);
        }
      })
      .catch((err) => {
        // TypeError: Cannot read properties of undefined (reading '0') 不能直接用message 会导致错误错误
        // 初步调研有可能这个时候组件已经卸载了 所以会导致
        // Warning: Can't perform a React state update on an unmounted component. This is a no-op, but it indicates a memory leak in your application. To fix, cancel all subscriptions and asynchronous tasks in the componentWillUnmount method.
        // message.error('err');
        console.log('上传白名单文件 err', err);
      });
  };

  const onChangeFile = (info: any) => {
    const file = info.file;
    const fileList = info.fileList;
    if (!file || !fileList) {
      throw new Error('本地文件上传内容为空！');
    }
  };

  function openWhiteListConfigManage() {
    (window.ACORE as any).openWhiteListDrawer.showManage({
      businessType: businessType,
      businessId: businessId,
      title: title,
      descriptionList: descriptionList,
    });
  }

  const handleCheckboxClick = (ev: any) => {
    const buttonDisabled = fileTaskList && fileTaskList.length > 0 && fileTaskList[0].status === 1;

    if (buttonDisabled) {
      setHaveComfirmCheckBox(true);
    } else {
      setHaveComfirmCheckBox(false);
      message.error('当前无法勾选，请先下载并查看审核文件');
    }
  };

  const getColumns = () => {
    let columns: any = [
      {
        dataIndex: 'fileName',
        title: '文件名称',
        width: 80,
      },
      {
        dataIndex: 'createTime',
        title: '上传时间',
        width: 150,
        render: (text: string, record: any) => <div>{formateTimeStamp(record.createTime, true)}</div>,
      },
      // status：状态, 0：处理中 1：处理完成 2：处理异常
      {
        dataIndex: 'status',
        title: '上传结果',
        width: 320,
        render: (val: number, record: any) => {
          return (
            <div>
              {val === 1 ? (
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'left' }}>
                  {record.fail > 0 ? (
                    <div>
                      <div>
                        <CheckCircleFilled
                          style={{ fontSize: '20px', color: '#1EC337', verticalAlign: 'middle', marginRight: '10px' }}
                        />
                        <span style={{ color: 'green' }}> {record?.success}</span>
                        个上传成功，可继续提交申请成功部分或重新上传
                      </div>
                      <div>
                        <CloseCircleFilled
                          style={{ fontSize: '20px', color: '#FF3126', verticalAlign: 'middle', marginRight: '10px' }}
                        />
                        <span style={{ color: 'red' }}> {record?.fail}</span>个上传失败
                        <Button style={{ padding: 0, marginLeft: '5px' }} type="link" href={record?.failUrl}>
                          下载查看失败原因
                        </Button>
                      </div>
                    </div>
                  ) : (
                    <div>
                      <CheckCircleFilled
                        style={{ fontSize: '20px', color: '#1EC337', verticalAlign: 'middle', marginRight: '10px' }}
                      />
                      <span style={{ verticalAlign: 'middle' }}>全部上传成功，请继续提交申请</span>
                    </div>
                  )}
                </div>
              ) : val === 0 ? (
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'left' }}>
                  <LoadingOutlined
                    style={{ fontSize: '20px', color: '#51b1fe', verticalAlign: 'middle', marginRight: '10px' }}
                  />
                  <span style={{ verticalAlign: 'middle', whiteSpace: 'nowrap' }}>上传中</span>
                  <span>50%</span>
                  <span style={{ color: '#a9a9a9' }}>「文件解析中，请耐心等待，请勿关闭页面」</span>
                </div>
              ) : (
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'left' }}>
                  <CloseCircleFilled
                    style={{ fontSize: '20px', color: '#FF3126', verticalAlign: 'middle', marginRight: '10px' }}
                  />
                  <span style={{ verticalAlign: 'middle' }}>{record?.remark || '上传失败，请检查文件后重新上传'}</span>
                </div>
              )}
            </div>
          );
        },
      },
      {
        dataIndex: 'operates',
        title: '操作',
        render: (val: number[] | null, record: any) => {
          return (
            <div>
              <Button
                style={{ padding: 0 }}
                type="link"
                onClick={() => {
                  getFileTaskResult(record?.fileTaskLogId);
                }}
              >
                刷新
              </Button>
            </div>
          );
        },
        width: 70,
      },
    ];
    return columns;
  };

  return (
    <>
      <Drawer width={1198} title="申请白名单" placement="right" onClose={onClose} visible={visible}>
        {!isManagerOpenAppliedList && (
          <Alert
            showIcon
            description={
              <div style={{ display: 'flex', alignItems: 'center' }}>
                提交申请后，请在“京东Me-流程中心”关注审核状态/进度;
                <ComponentLog clstag="yx_whiteapply_page_1706591686206|4">
                  <Button style={{ marginLeft: '10px', padding: '0px' }} type="link" onClick={() => setApplyInfo(true)}>
                    查看审核流程说明
                  </Button>
                </ComponentLog>
              </div>
            }
            type="info"
            closable
          />
        )}
        <div style={{ marginTop: '15px' }}>
          <HeaderInfo
            title={title}
            descriptionList={descriptionList}
            rightBtn={
              isPartner &&
              (businessId ? (
                <Button type="primary" ghost onClick={() => openWhiteListConfigManage()}>
                  白名单管理
                </Button>
              ) : (
                <AuthDistribute id={whiteTypeId} isPartner={true}>
                  <Button type="primary" ghost>
                    权限分配
                  </Button>
                </AuthDistribute>
              ))
            }
          />
        </div>
        <Tabs defaultActiveKey={tabType} activeKey={tabType} onChange={onChange}>
          {!isManagerOpenAppliedList && (
            <Tabs.TabPane tab="可申请" key="1">
              <Form form={form}>
                <h3>1、选择白名单</h3>
                <Form.Item
                  label="白名单类型"
                  name="whiteTemplateId"
                  labelAlign="left"
                  style={{ display: 'flex', flexDirection: 'column', width: 367 }}
                  rules={[{ required: true, message: '请选择白名单类型' }]}
                >
                  <Select
                    disabled={whiteTypeId !== -1}
                    getPopupContainer={(triggerNode) => triggerNode.parentNode}
                    placeholder="请选择"
                    onChange={(value: any) => {
                      setWhiteTemplateTypeId(value);
                      const curItemData = whiteTypeList?.find((item: any) => item.id === value);
                      if (curItemData) {
                        setWhiteTemplateType(curItemData?.whiteType);
                      }
                      onCurSelectTypeChange(value);
                    }}
                  >
                    {whiteTypeList?.map((item: any) => {
                      return (
                        <Select.Option key={item.id} value={item.id}>
                          {item.whiteName}
                        </Select.Option>
                      );
                    })}
                  </Select>
                </Form.Item>
                {[3].includes(businessType) && (
                  <Form.Item
                    name="effectiveTime"
                    label="白名单生效时间"
                    labelAlign="left"
                    required={true}
                    style={{ display: 'flex', flexDirection: 'column', width: 367 }}
                    extra={<div style={{ color: 'red' }}>仅在该时间段内白名单生效，过期后失效</div>}
                  >
                    <TimestampRangePicker disabled={true} showTime />
                  </Form.Item>
                )}

                <div style={{ display: 'flex' }}>
                  <h3>2、填写基础信息</h3>
                  <a style={{ marginLeft: '10px' }} onClick={() => setRuleModalVisible(true)}>
                    了解申请须知（必读）
                  </a>
                </div>
                {fromDataConfig?.list && (
                  <ApplyBaseFrom
                    fromData={fromDataConfig?.list.filter((item: any) => item.code !== 'whiteTextSelect')}
                    form={form}
                    visible={visible}
                    onFormSubmit={handleBaseFormSubmit}
                    delFileList={fileList}
                  />
                )}
                <h3>3、上传白名单</h3>
                <Form.Item
                  label="选择表单填写方式"
                  name="whiteTextSelect"
                  labelAlign="left"
                  style={{ display: 'flex', flexDirection: 'column', width: 400 }}
                  rules={[{ required: true, message: '请选择表单填写方式' }]}
                >
                  <Radio.Group onChange={onFromWhiteChange}>
                    {whiteTextSelect?.map((item: any) => {
                      return (
                        <Radio key={item.value} value={item.value}>
                          {item.text}
                        </Radio>
                      );
                    })}
                  </Radio.Group>
                </Form.Item>
                <div
                  style={{
                    display: 'flex',
                  }}
                >
                  <Form.Item
                    label="上传白名单"
                    name="fileTaskLogId"
                    labelAlign="left"
                    style={{ display: 'flex', flexDirection: 'column' }}
                    rules={[
                      {
                        required: true,
                        validator: (_, value) => {
                          return new Promise((resolve, reject) => {
                            if (value) {
                              return resolve('');
                            }
                            if (fileTaskLogId !== -1 && fileType) {
                              return resolve('');
                            }
                            if (fileTaskLogId === -1 && !fileType) {
                              return reject(new Error('请先选择表单填写方式，再上传白名单文件'));
                            }
                            if (fileTaskLogId === -1 && fileType) {
                              return reject(new Error('请上传白名单文件'));
                            }
                          });
                        },
                      },
                    ]}
                  >
                    <Upload
                      accept=".xls,.xlsx"
                      name="file"
                      showUploadList={false}
                      maxCount={1}
                      onChange={(info: any) => {
                        onChangeFile(info);
                      }}
                      customRequest={customRequest}
                    >
                      <div style={{ color: '#a9a9a9', margin: '8px 0' }}>
                        请严格按照模版中的字段规则填写：支持扩展名为xls/xlsx的文件;
                      </div>
                      <ComponentLog clstag="yx_whiteapply_page_1706591686206|6">
                        <Button type="primary" style={{ marginRight: '10px' }} ghost>
                          上传文件
                        </Button>
                      </ComponentLog>
                    </Upload>
                  </Form.Item>
                  <ComponentLog clstag="yx_whiteapply_page_1706591686206|7">
                    <Button
                      style={{ marginLeft: '-300px', padding: '0px', marginTop: '70px' }}
                      type="link"
                      href={whiteTextSelect?.find((item: any) => item.value === fileType)?.url}
                      onClick={() => {
                        if (!fileType) {
                          message.error('请先选择表单填写方式，再下载模板');
                        }
                      }}
                    >
                      下载模板
                    </Button>
                  </ComponentLog>
                </div>
                <Table
                  bordered
                  style={{
                    margin: '0 auto',
                    width: '100%',
                    height: '100%',
                    overflow: 'hidden',
                    marginBottom: '10px',
                  }}
                  columns={getColumns()}
                  dataSource={fileTaskList}
                  pagination={false}
                />
                <h3>4、确认白名单审核信息</h3>
                <div style={{ color: '#a9a9a9', margin: '8px 0' }}>
                  为提高审核效率，系统会将您提交的表格内容进行信息拓展，主要包含（商品名称、类目名称、商品所属人信息等），审核人将看到拓展后的表格内容
                </div>
                <ComponentLog clstag="yx_whiteapply_page_1706591686206|15">
                  <Button
                    type="primary"
                    style={{ marginRight: '10px' }}
                    ghost
                    href={fileTaskList && fileTaskList.length > 0 && fileTaskList[0].successUrl}
                    disabled={!(fileTaskList && fileTaskList.length > 0 && fileTaskList[0].status === 1)}
                  >
                    下载并查看审核文件
                  </Button>
                </ComponentLog>
                <Form.Item
                  label=""
                  name="comfirmApprovalFile"
                  labelAlign="left"
                  style={{ display: 'flex', flexDirection: 'column', width: 400, marginBottom: '60px' }}
                  rules={[
                    {
                      required: true,
                      validator: (_, value) => {
                        return new Promise((resolve, reject) => {
                          if (haveComfirmCheckBox) {
                            return resolve('');
                          } else {
                            return reject(new Error('请勾选我已查看审核文件并确认白名单信息无误'));
                          }
                        });
                      },
                    },
                  ]}
                >
                  <Checkbox onChange={handleCheckboxClick} checked={haveComfirmCheckBox}>
                    <span>我已查看审核文件并确认白名单信息无误</span>
                  </Checkbox>
                </Form.Item>
              </Form>
              <div
                style={{
                  height: '64px',
                  alignItems: 'center',
                  display: 'flex',
                  position: 'fixed',
                  bottom: '0',
                  width: '1198px',
                  right: '0',
                  zIndex: '8',
                  background: '#fff',
                  boxShadow: '0px 0px 16px rgba(0, 0, 0, 0.08), 0px 8px 24px 8px rgba(0, 0, 0, 0.04)',
                  justifyContent: 'center',
                }}
              >
                <Button type="primary" ghost onClick={onClose}>
                  取消
                </Button>
                <ComponentLog clstag="yx_whiteapply_page_1706591686206|5">
                  <Button
                    style={{
                      marginLeft: '20px',
                    }}
                    type="primary"
                    onClick={checkFromContent}
                  >
                    提交申请
                  </Button>
                </ComponentLog>
              </div>
              <Modal
                visible={ruleModalVisible}
                width={400}
                title="白名单申请须知"
                onCancel={() => setRuleModalVisible(false)}
                footer={[
                  <div style={{ textAlign: 'center' }}>
                    <Button
                      type="primary"
                      onClick={() => {
                        setRuleModalVisible(false);
                      }}
                    >
                      我知道了
                    </Button>
                  </div>,
                ]}
              >
                <div
                  dangerouslySetInnerHTML={{
                    __html: whiteTypeList?.find((item: any) => item.id === whiteTemplateTypeId)?.applyContent ?? '',
                  }}
                />
              </Modal>
              <ApproveModel
                approveInfoModalVisible={applyInfo}
                setApproveInfoModalVisible={setApplyInfo}
                approveRemarkSaler={fromDataConfig?.approveRemarkSaler}
                approveRemarkNoSaler={fromDataConfig?.approveRemarkNoSaler}
              />
              <Modal
                visible={againSubmit}
                width={428}
                onCancel={() => setAgainSubmit(false)}
                footer={[
                  <div style={{ textAlign: 'center' }}>
                    <Button
                      ghost
                      type="primary"
                      onClick={() => {
                        setAgainSubmit(false);
                      }}
                    >
                      取消
                    </Button>
                    <Button loading={submitLoading} type="primary" onClick={submitWhiteApply}>
                      立即提交
                    </Button>
                  </div>,
                ]}
              >
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'left',
                  }}
                >
                  <img src={SubmitTopSvg} />
                  <h3 style={{ marginTop: '10px' }}>确认提交申请吗？</h3>
                  <div>提交将进入审核流程，全部审核通过的白名单才可生效;审核流程如下:</div>
                  <AugitFlow
                    approveRemarkSaler={fromDataConfig?.approveRemarkSaler}
                    approveRemarkNoSaler={fromDataConfig?.approveRemarkNoSaler}
                  />
                </div>
              </Modal>
            </Tabs.TabPane>
          )}
          <Tabs.TabPane tab="已申请" key="2">
            <AppliedList
              businessType={businessType}
              businessId={businessId}
              tabType={tabType}
              whiteTemplateId={whiteTemplateId}
            />
          </Tabs.TabPane>
        </Tabs>
      </Drawer>
    </>
  );
}

export default Apply;
